import React from 'react'
import { isPerfX, WHITE_LOGO_CDN_URL } from '../constants/constants'

const AuthLayout: React.FC<{ children: React.ReactNode[] | React.ReactNode, action?: React.ReactNode, leftAction?: React.ReactNode }> = ({ children, action, leftAction }) => {
    return (
        <div className='full-screen auth-bg'>
            {
                (action || leftAction) ? (
                    <div className="auth-layout-actions">
                        <div>{leftAction}</div>
                        <div>{action}</div>
                    </div>
                ) : null
            }
            <div className='auth-brand d-flex align-items-center justify-content-center flex-column'>
                <img src={WHITE_LOGO_CDN_URL} className='auth-brand-logo' style={{height: isPerfX ? '4.75rem' : '2.75rem'}} />
                <span className='auth-brand-tagline'>Where your influence matters</span>
            </div>
            <div className="auth-content">
                {children}
            </div>
            <div className="auth-circles"></div>
        </div>
    )
}

export default AuthLayout